module.exports = __webpack_public_path__ + "img/sfondo-patate-al-forno.4c3eab7f.png";